import request from '../../utils/request';

/** 查询视频源配置（只回 video 段，模型配置不外送） */
export function fetchVideoConfig() {
  return request.get('/blissrose/video/config');
}

/** 修改视频源配置：只放行视频源字段，改完重新开始拉流才生效 */
export function updateVideoConfig(body) {
  return request.put('/blissrose/video/config', body);
}

/** 查询运行状态与播放进度（画面走 SSE；这条按秒轮询，只同步状态） */
export function fetchVideoStatus() {
  return request.get('/blissrose/video/status');
}

/** 开始拉流推理 */
export function startVideo() {
  return request.post('/blissrose/video/start');
}

/** 停止拉流 */
export function stopVideo() {
  return request.post('/blissrose/video/stop');
}

/** 暂停 / 继续（paused: true 暂停，false 继续） */
export function pauseVideo(paused) {
  return request.post('/blissrose/video/pause', { paused });
}

/** 设置播放倍速（0.25 ~ 4，越界由后端截断） */
export function setVideoSpeed(speed) {
  return request.post('/blissrose/video/speed', { speed });
}

/** 跳到指定帧（仅图片帧目录源有效） */
export function seekVideo(frameIndex) {
  return request.post('/blissrose/video/seek', { frame_index: frameIndex });
}

/** 同帧推流 URL（SSE；每帧的图与检测结果在同一个事件里，不能走 axios） */
export function getVideoStreamUrl({ since = 0, epoch = '', img = true } = {}) {
  const params = new URLSearchParams({
    since: String(since),
    epoch,
    img: img ? '1' : '0',
  });
  return `/api/blissrose/video/stream?${params.toString()}`;
}
